import { de, enUS, fi, nb, sv } from "date-fns/locale"
import { useTranslation } from "react-i18next"

import type { Locale } from "date-fns"

// Every language in `supportedLngs` (languageConfig.ts) needs an entry here,
// or its relative dates ("3 days ago") silently fall back to English (#2968).
const localeMap: Record<string, Locale> = {
  en: enUS,
  sv: sv,
  no: nb,
  fi: fi,
  de: de,
}

export function useDateLocale(): Locale {
  const { i18n } = useTranslation()
  const languageCode = (i18n.resolvedLanguage || i18n.language || "en").split("-")[0]
  return localeMap[languageCode] ?? enUS
}
